// @ts-strict-ignore
import type { AggregationSourceData } from './types';
import type { Option } from '@usealloy/component-library';
import { AggregationFilterOperatorType, AggregationType, TimeframeUnit } from 'flow/store/engine/constants';

// TODO(OAK-1060): Remove INITIAL_AGGREGATION_CONFIG once all sourceData
// fields (scope, timeframe) are persisted in AggregationComponent and
// transformations are complete.
export const INITIAL_AGGREGATION_CONFIG: AggregationSourceData = {
  name: 'Entities',
  description: '',
  aggregation: {
    columnSlug: 'entity_token',
    aggregationType: AggregationType.COUNT_DISTINCT,
  },
  scope: 'all',
  filters: [],
  timeframeIntervalStart: 0,
  timeframeIntervalEnd: 90,
  timeframeUnit: TimeframeUnit.DAYS,
};

export const AGGREGATION_TYPE_LABELS: Record<AggregationType, string> = {
  [AggregationType.COUNT_DISTINCT]: 'Distinct Count',
  [AggregationType.COUNT]: 'Count',
  [AggregationType.SUM]: 'Sum',
  [AggregationType.AVG]: 'Average',
  [AggregationType.MIN]: 'Min',
  [AggregationType.MAX]: 'Max',
};

// TODO(OAK-1060): Update this to use dynamic filter operator options from config object
export const FILTER_OPERATOR_OPTIONS: Option[] = [
  { value: AggregationFilterOperatorType.EQ, label: '=' },
  { value: AggregationFilterOperatorType.NE, label: '!=' },
  { value: AggregationFilterOperatorType.LT, label: '<' },
  { value: AggregationFilterOperatorType.LTE, label: '<=' },
  { value: AggregationFilterOperatorType.GT, label: '>' },
  { value: AggregationFilterOperatorType.GTE, label: '>=' },
  { value: AggregationFilterOperatorType.IN, label: 'in' },
  { value: AggregationFilterOperatorType.BT, label: 'between' },
];

export const BOOLEAN_FILTER_OPTIONS: Option[] = [
  { value: 'true', label: 'true' },
  { value: 'false', label: 'false' },
];

export const SCOPE_OPTIONS: Option[] = [
  { value: 'entity', label: 'For the Entity being evaluated' },
  { value: 'group', label: 'For all Entities in this Group' },
  { value: 'all', label: 'Across all Entities' },
];

export const TIMEFRAME_UNIT_OPTIONS: Option[] = Object.values(TimeframeUnit).map(
  value => ({ value, label: value }),
);

export const TIMEFRAME_MAX_DAYS_BY_SCOPE: Record<string, number> = {
  all: 90,
  entity: 365,
  group: 365,
};

const DAYS_TO_UNIT_MULTIPLIER: Record<TimeframeUnit, number> = {
  [TimeframeUnit.MINUTES]: 24 * 60,
  [TimeframeUnit.HOURS]: 24,
  [TimeframeUnit.DAYS]: 1,
  [TimeframeUnit.MONTHS]: 1 / 30,
};

export function getTimeframeMax(scope: string, unit: TimeframeUnit): number {
  const maxDays = TIMEFRAME_MAX_DAYS_BY_SCOPE[scope] ?? 90;
  return Math.floor(maxDays * DAYS_TO_UNIT_MULTIPLIER[unit]);
}
